import Vue from 'vue';
import Router from 'vue-router';

import login from './components/pages/login'
import dashboard from './components/pages/dashboard'
import createOrder from './components/pages/create_order'
import createOrderType from './components/pages/create_order_type'
import editOrder from './components/pages/edit_order'
import orders from './components/pages/orders'
import combineorders from './components/pages/combineorders'
import weborders from './components/pages/weborders'
import ordersType from './components/pages/ordersType'

import createDebtor from './components/pages/create_debtor'
import editDebtor from './components/pages/edit_debtor'
import debtors from './components/pages/debtors'

Vue.use(Router);

var router=new Router({
    mode:'history',
    routes:[
        {
            path:'/',
            component:dashboard,
            redirect:{
                path:'/dashboard'
            }
        },
        {
            path:'/login',
            component:login
        },
        {
            path:'/dashboard',
            component:dashboard,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/orders',
            component:orders,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/combineorders',
            component:combineorders,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/weborders',
            component:weborders,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/orders/:type',
            component:ordersType,
            meta:{
                AuthRequired:true
            },
            props: (route) => ({
                type : route.params.type
            }),
        },
        {
            path:'/create-order/:type',
            component:createOrderType,
            meta:{
                AuthRequired:true
            },
            props: (route) => ({
                type : route.params.type
            }),
        },
        {
            path:'/create-order',
            component:createOrder,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/edit-order/:id',
            component:editOrder,
            meta:{
                AuthRequired:true
            },
            props: (route) => ({
                id : parseInt(route.params.id)
            }),
        },
        {
            path:'/debtors',
            component:debtors,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/create-debtor',
            component:createDebtor,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/edit-debtor/:id',
            component:editDebtor,
            meta:{
                AuthRequired:true
            },
            props: (route) => ({
                id : parseInt(route.params.id)
            }),
        },
    ]
});

export default router;

router.beforeEach((to,from,next)=>{
    if(to.matched.some(record => record.meta.AuthRequired)) { 
        if (localStorage.getItem('api_token') == null) { 
            window.location.href='/login';
        } 
        else{ 
            console.log(localStorage.getItem('api_token') );
            next(); 
        }
    }
    
    next(); 
})